import Authenticate from "components/Authentication/Authenticate";
import { withAuthenticator } from "components/Authentication/withAuthenticator";
import { BrowserRouter as Router } from "react-router-dom";
import { StateMachineProvider, createStore } from "little-state-machine";
import { Container } from "react-bootstrap";
import { Footer } from "@whitespace/whitespace-ui";
import Routes from "infrastructure/Routes";
import Banner from "infrastructure/Banner";
import { DevTool } from "little-state-machine-devtools";
import "@whitespace/whitespace-ui/dist/whitespace-ui.css";
import { initialState } from "modules/InitialState";

createStore(initialState(), {});

// Syncfusion licence

const App = () => (
  <StateMachineProvider>
    {
      process.env.NODE_ENV !== "production"
      && process.env.REACT_APP_AMPLIFY_LIVE_MODE === "true"
      && <DevTool buttonBottom={0} buttonTop="auto" aria-label="LSM" />
    }
    <Authenticate />
    <Router>
      <a href="#content" className="skippy visually-hidden overflow-hidden" title="Skip menu to page content">
        Skip to content
      </a>
      <Banner />
      <Container id="content" fluid>
        <Routes />
      </Container>
      <Footer />
    </Router>
  </StateMachineProvider>
);

export default withAuthenticator(App);
